import React from "react";

import "./subscription-providers.css";

import Searchinput from "app/components/search-input/Searchinput";

function SubscriptionProviders() {
  return (
    <>
      <Searchinput title="Type Your Provider Name" />
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>AHA</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>Disney+Hotstar</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>EPIC ON</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>Gaana Plus</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>Hungama Music</h3>
        </div>
      </div>
    </>
  );
}

export default SubscriptionProviders;
